import React, { useEffect, useState } from "react";
import styles from "../../asset/css/launchpadDetailsPage.module.css";
import Classes from '../../asset/styles/PrivateSalesCard.module.css'

import Header from '../../components/global/Header';
import { Images } from '../../data/Images';
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link, useParams, NavLink } from 'react-router-dom';
import bitcoinVideo from "../../asset/images/nexus/bitcoinVideo.mp4";
import Usesale from '../../hooks/useSale';
import Usetoken from '../../hooks/useToken';
import { useDispatch, useSelector } from 'react-redux';
import Countdown from "react-countdown";


import { getallsalehook } from "../../actions/userAction";
import { LAMPORTS_PER_SOL } from "@solana/web3.js";
import toast from "react-hot-toast";
import { isEmpty } from "../../lib/isEmpty";
import Config from "../../config"
import ThemeImg from "../../components/global/ThemeImg";

export default function LaunchpadDetailsPage() {


    const saleHook = Usesale()
    const params = useParams()
    const tokenHook = Usetoken()

    const [steps, setSteps] = useState(1);
    const [saleType, setSaleType] = useState("public");
    const [show, setShow] = useState(false)
    const handleClose = () => setShow(false)
    const handleShow = () => setShow(true)
    const [wallet, setWallet] = useState(false)
    const [saleInfo, setSaleInfo] = useState({})
    const [saleDBInfo, setSaleDBInfo] = useState({})
    const [userData, setUserData] = useState({})
    const [max, setMax] = useState(0)
    const [isMax, setIsMax] = useState(false)
    const [amount, setAmount] = useState(0)
    const [saleAdd, setSaleAdd] = useState('')
    const [tokeninfo, setTokeninfo] = useState({})
    const [isbuy, setIsbuy] = useState(false)
    const [isclaim, setIsclaiming] = useState(false)
    const [isfinalize, setIsfinalize] = useState(false)
    const [userinfo, setUserinfo] = useState({})
    const [whitelistUserBuy, setwhitelistUserBuy] = useState(0)
    const [deposit, setDeposit] = useState(0)
    const [isdeposit, setIsdeposit] = useState(false)
    const [errors, setErrors] = useState({})
    const [buy, setBuy] = useState(false)
    const [status, setStatus] = useState(true);
    const [remainingbuyAmount, setremainingbuyAmount] = useState(0);
    const [walletAddress, setwalletAddress] = useState(sessionStorage.getItem("walletAddress"))
    const walletdetail = useSelector((state) => state.wallet)



    useEffect(() => {
        setwalletAddress(sessionStorage.getItem("walletAddress"))
        getSaleData()

        console.log("walletdetail>>>>>", walletdetail);

    }, [walletdetail?.walletaddress])

    useEffect(() => {
        if (walletdetail?.walletaddress) {
            getUserData()
        }
    }, [params?.saleAddress, walletdetail?.walletaddress])

    const getUserData = async () => {
        console.log('getUserData', walletdetail?.walletaddress)
        let userData = await saleHook.UseUserBookings(params?.saleAddress, walletdetail?.walletaddress)
        console.log("userData", userData, userData?.tokensBooked / LAMPORTS_PER_SOL)
        setUserinfo(userData)

    }

    const getSaleData = async () => {

        let datas = await saleHook?.UseSaleInfo(params?.saleAddress)
        setSaleAdd(params?.saleAddress)
        setSaleInfo(datas)


        const getSalefromDb = await getallsalehook()
        console.log("getSalefromDb", getSalefromDb?.data?.data);

        const data = getSalefromDb?.data?.data;
        let DBData = {}
        if (data?.length > 0) {
            DBData = data?.find((val) => (val?.saleAddress == params?.saleAddress))
        }
        console.log("DBDataDBData", DBData);

        setSaleDBInfo(DBData)
    }


    const OnchangeBuy = (value) => {
        var errors = {}
        if (value > (parseInt(saleInfo?.maximumBuy) / LAMPORTS_PER_SOL)) {
            errors.amount = "Amount should not be greater than max amount"
            setBuy(true)
        }
        else if (value < (parseInt(saleInfo?.minimumBuy) / LAMPORTS_PER_SOL)) {
            errors.amount = "Amount should not be lesser than min amount"
            setBuy(true)
        }
        else {
            errors.amount = ""
            setBuy(false)
        }
        setErrors(errors)
        return errors
    }
    const maxBuy = async () => {
        setMax(saleInfo && (parseInt(saleInfo?.maximumBuy) / LAMPORTS_PER_SOL))
        setIsMax(true)
        setAmount(saleInfo && (parseInt(saleInfo?.maximumBuy) / LAMPORTS_PER_SOL))

    }


    const Claim = async () => {
        setIsclaiming(true)
        var result = await saleHook.UseClaimToken(saleInfo?.splMint, saleAdd)
        console.log("finalizeSale_result", result)
        setIsclaiming(false)
        getUserData()
        if (result?.status == true) {
            toast.success('Sale claimed Successfully')
        }
        else if (result?.status == false && saleInfo?.isVested == true) {
            if (!isEmpty(result.error)) {
                toast.error(result.error)
            }
            else {
                toast.error('Sale not claimed')
            }

        }
        else if (result?.status == false) {
            toast.error('Sale not claimed')
        }


    }


    const finalizeSale = async () => {
        if (saleInfo?.launchType == "Launchpad" || saleInfo?.launchType == "Private Sale") {
            setIsfinalize(true)
            var result = await saleHook.UseClosePresale(saleInfo?.splMint)
            console.log("finalizeSale_result", result)
            setIsfinalize(false)
            getSaleData()
            result?.status == true ?
                toast.success('Sale finalized Successfully')
                :
                toast.error('Sale not finalized')
        }
        else {
            setIsfinalize(true)
            var result = await saleHook.UseClosePresaleFairLaunch(saleInfo?.splMint)
            console.log("finalizeSale_result_fair", result)
            setIsfinalize(false)
            getSaleData()
            result?.status == true ?
                toast.success('Sale finalized Successfully')
                :
                toast.error('Sale not finalized')
        }

    }







    const buyToken = async () => {

        setIsbuy(true)
        if (saleInfo?.launchType == "FairLaunch") {

            if (saleInfo?.isWhitelist == false && saleInfo?.useWithToken == false) {
                var result = await saleHook.UseBookTokenFairLaunch(amount * LAMPORTS_PER_SOL, saleInfo?.splMint, saleAdd)
                console.log("buyToken_result_fair", result)
                getSaleData()
                getUserData()
                setAmount(0)
                setIsbuy(false)
                result?.status == true ?
                    toast.success('Token booked Successfully')
                    :
                    toast.error('Token not booked')

            }

            else if (saleInfo?.isWhitelist == false && saleInfo?.useWithToken == true) {
                var result = await saleHook.UseBookTokenUseWithToken(amount * LAMPORTS_PER_SOL, saleInfo?.splMint, saleInfo?.buyMint, saleAdd)
                console.log("buyToken_result_fair", result)
                getSaleData()
                getUserData()
                setAmount(0)
                setIsbuy(false)
                result?.status == true ?
                    toast.success('Token booked Successfully')
                    :
                    toast.error('Token not booked')

            }
        }
    }


    const renderer = ({ days, hours, minutes, seconds }) => {
        return (
            <div className={`${Classes.countdownRenderer} d-flex justify-content-center align-items-center`}>
                <p className={`${Classes.card__counter} m-0 px-2 p-lg-2 p-xl-3 px-sm-3 mx-1 mx-sm-2 mx-lg-1 mx-xl-2 dayset text-center position-relative roboto`}>{
                    days < 10 ? `0${days}` : days}
                    <span className='text-center'>Days</span>
                </p>
                <p className={`${Classes.card__counter} m-0 px-2 p-lg-2 p-xl-3 px-sm-3 mx-1 mx-sm-2 mx-lg-1 mx-xl-2 dayset text-center position-relative roboto`}>{hours < 10 ? `0${hours}` : hours}
                    <span className='text-center'>Hrs</span>
                </p>
                <p className={`${Classes.card__counter} m-0 px-2 p-lg-2 p-xl-3 px-sm-3 mx-1 mx-sm-2 mx-lg-1 mx-xl-2 dayset text-center position-relative roboto`}>{minutes < 10 ? `0${minutes}` : minutes}
                    <span className='text-center'>Mins</span>
                </p>
                <p className={`${Classes.card__counter} m-0 px-2 p-lg-2 p-xl-3 px-sm-3 mx-1 mx-sm-2 mx-lg-1 mx-xl-2 dayset text-center position-relative roboto`}>{seconds < 10 ? `0${seconds}` : seconds}
                    <span className='text-center'>Secs</span>
                </p>
            </div>
        )
    }

    let ClaimAmount = amount * (saleInfo?.ppt / LAMPORTS_PER_SOL);
    var percentage = saleInfo && parseInt(parseInt(saleInfo?.currencyRaised / LAMPORTS_PER_SOL) / parseInt(saleInfo?.softCap / LAMPORTS_PER_SOL) * 100)



    return (
        <div className={styles.launchpadDetailsPage}>
            <Header />
            <div className={styles.pageHeaderPart}>
                <Link to="/">
                    <button>
                        <FaArrowLeftLong />
                    </button>
                    <span>Back</span>
                </Link>
            </div>


            {saleDBInfo && saleDBInfo.saleAddress ?
                <>
                    {saleInfo && saleHook.isUpcoming(parseInt(saleInfo?.presaleStart)) ?

                        <div> <Countdown date={Date.now() + saleHook.Salediffernce(parseInt(saleInfo?.presaleStart))} renderer={renderer} />

                            <p className="text-center textclr mb-3">Coming up </p>
                        </div> :
                        saleInfo && saleInfo.ready !== 2 && saleHook.isSaleLive(saleInfo.presaleStart, saleInfo.presaleEnd) ?
                            <div><Countdown date={Date.now() + saleHook.Salediffernce(parseInt(saleInfo?.presaleEnd))} renderer={renderer} />

                                <p className="text-center textclr mb-3"> Ends in </p>
                            </div> :
                            saleInfo.ready == 2 || saleHook.isSaleEnded(parseInt(saleInfo?.presaleStart), parseInt(saleInfo?.presaleEnd)) ?

                                <div >

                                    <p className="text-center textclr mb-3">Closed </p>
                                </div> : <></>}
                    <div className={styles.bodyContentPart}>
                        <div className={styles.leftDetailsPart}>
                            <div className={styles.bannerImgPart}>
                                <img src={Images.cardBgImg2} alt="cardBgImg" />
                            </div>
                            <div className={styles.launchpadBodyPart}>
                                <div className={styles.logoPart}>
                                    <img src={saleDBInfo?.logo ? saleDBInfo?.logo : Images.cardCoinImg} alt="coin" />
                                    <p>                            {saleDBInfo?.name ? saleDBInfo?.name : 'Nexus'}
                                    </p>
                                </div>
                                <div className={styles.socialMediaIcons}>
                                    <ul>
                                        <li>
                                            <NavLink to={saleDBInfo?.twitter}>
                                                <img src={Images.twitterIcon} alt="twitter" />
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to={saleDBInfo?.telegram}>
                                                <img src={Images.telegramIcon} alt="telegram" />
                                            </NavLink>
                                        </li>
                                        {/* <li>
                                    <NavLink to={saleDBInfo?.telegram}>
                                        <img src={Images.facebookIcon} alt="facebook" />
                                    </NavLink>
                                </li> */}
                                        <li>
                                            <NavLink to={saleDBInfo?.discord}>
                                                <img src={Images.discordIcon} alt="discord" />
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>
                                <div className={styles.textContentPart}>
                                    <p>  {saleDBInfo?.description}</p>

                                </div>
                                <div className={styles.listPart}>
                                    <ul>

                                        <li>
                                            <h2>Token Address</h2>
                                            <p>
                                                <span className={styles.idText}>
                                                    {saleInfo && saleInfo?.splMint?.toString()}
                                                </span>
                                            </p>
                                        </li>
                                        <li>
                                            <h2>Sale Type</h2>
                                            <p>
                                                {saleInfo && saleInfo?.launchType ? saleInfo?.launchType : "FairLaunch"}
                                            </p>
                                        </li>
                                        <li>
                                            <h2>Token Name</h2>
                                            <p>
                                                {saleDBInfo?.name ? saleDBInfo?.name : 'Nexus'}
                                            </p>
                                        </li>
                                        <li>
                                            <h2>Token Symbol</h2>
                                            <p>
                                                {saleDBInfo?.symbol}
                                            </p>
                                        </li>

                                        <li>
                                            <h2>Softcap</h2>
                                            <p>
                                                {saleInfo?.softCap / LAMPORTS_PER_SOL}{" "}
                                                {saleInfo?.buyMint?.toString() == Config?.SOL ? "SOL" : "USDT"}
                                            </p>
                                        </li>
                                        {/* <li>
                                    <h2>Hardcap</h2>
                                    <p>
                                        {saleInfo?.hardCap / LAMPORTS_PER_SOL}{" "}
                                        {saleInfo?.buyMint?.toString() == Config?.SOL ? "SOL" : "USDT"}
                                    </p>
                                </li> */}
                                        <li>
                                            <h2>Start Time</h2>
                                            <p>
                                                {saleInfo && new Date(parseInt(saleInfo?.presaleStart)).toLocaleDateString() + "  "
                                                    + new Date(parseInt(saleInfo?.presaleStart)).getHours() + ":" + new Date(parseInt(saleInfo?.presaleStart)).getMinutes() + ":"
                                                    + new Date(parseInt(saleInfo?.presaleStart)).getSeconds()}
                                            </p>
                                        </li>
                                        <li>
                                            <h2>End Time</h2>
                                            <p>
                                                {saleInfo && new Date(parseInt(saleInfo?.presaleEnd)).toLocaleDateString() + "  "
                                                    + new Date(parseInt(saleInfo?.presaleEnd)).getHours() + ":" + new Date(parseInt(saleInfo?.presaleEnd)).getMinutes() + ":"
                                                    + new Date(parseInt(saleInfo?.presaleEnd)).getSeconds()}
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                                <div className={styles.videoPart}>
                                    <iframe src={saleDBInfo?.youtube ? saleDBInfo?.youtube : "https://www.youtube.com/embed/GlSljWV0dFI?si=cmtlQbVzMfRCKVt1"} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                        <div className={styles.rightDetailsPart}>
                            <div className={styles.connectNetworkPart}>
                                <h2>Connect Network To</h2>
                                <img src={Images.diamentImg} alt="diament" />
                                <h2>Solana</h2>
                            </div>
                            <div className={styles.saleEndPart}>
                                {saleInfo && saleHook.isUpcoming(parseInt(saleInfo?.presaleStart)) ?

                                    <div className={styles.titlePart}>
                                        <h2>Coming up</h2>
                                    </div>
                                    : saleInfo && saleInfo.ready !== 2 && saleHook.isSaleLive(saleInfo.presaleStart, saleInfo.presaleEnd) ?
                                        <div className={styles.titlePart}>
                                            <h2>Live</h2>
                                        </div> : saleInfo.ready == 2 || saleHook.isSaleEnded(parseInt(saleInfo?.presaleStart), parseInt(saleInfo?.presaleEnd)) ?
                                            <div className={styles.titlePart}>
                                                <h2>Closed</h2>
                                            </div> : <></>
                                }
                                <div className={styles.progressInputContainer}>
                                    {/* <label htmlFor="">Not Live</label> */}
                                    <input type="range"
                                        readOnly={true}
                                        value={saleInfo && percentage > 100 ? 100 : parseInt((saleInfo?.currencyRaised / LAMPORTS_PER_SOL) / (saleInfo?.softCap / LAMPORTS_PER_SOL) * 100)} />

                                    <div className={styles.rangeValue}>
                                        <p>{saleInfo?.currencyRaised ? `${(saleInfo && percentage > 100 ? 100 : parseInt((saleInfo?.currencyRaised / LAMPORTS_PER_SOL) / (saleInfo?.softCap / LAMPORTS_PER_SOL) * 100))} %` : "0 %"}</p>
                                        <p>{saleInfo && (parseInt(saleInfo?.currencyRaised) / LAMPORTS_PER_SOL)}  {saleInfo?.buyMint?.toString() == Config?.SOL ? "SOL" :
                                            saleInfo?.buyMint?.toString() == Config?.USDT ? "USDT" :
                                                saleInfo?.buyMint?.toString() == Config?.USDC ? "USDC" : "DAI"}{" "}/ {(parseInt(saleInfo?.softCap) / LAMPORTS_PER_SOL)}  {saleInfo?.buyMint?.toString() == Config?.SOL ? "SOL" :
                                                    saleInfo?.buyMint?.toString() == Config?.USDT ? "USDT" :
                                                        saleInfo?.buyMint?.toString() == Config?.USDC ? "USDC" : "DAI"}</p>
                                    </div>
                                </div>
                                <div className={styles.contributeTablePart}>
                                    {saleInfo?.launchType == "FairLaunch" && isEmpty(saleInfo?.splStock) ?

                                        <h2 className={styles.headingPart}>
                                            you will get: {" "}{ClaimAmount} {saleDBInfo?.symbol}
                                        </h2> : <></>}
                                    <div className={styles.contributeAmountPart}>
                                        <div className="w-100">
                                            <label htmlFor="">Amount</label>
                                            <div>
                                                <input type="number"
                                                    autoComplete="off"
                                                    value={amount}
                                                    onChange={(e) => {
                                                        var numbers = /^\d+((.)|(.\d{0,4})?)$/;
                                                        if (!numbers.test(e.target.value) && e.target.value !== "") {
                                                            return false
                                                        }
                                                        setAmount(e.target.value);
                                                        OnchangeBuy(e.target.value)
                                                    }} />

                                                <button className={"primaryBtn"}
                                                    onClick={async () => {
                                                        await maxBuy()
                                                        console.log("buyyy", saleInfo && (parseInt(saleInfo?.maximumBuy) / LAMPORTS_PER_SOL))
                                                    }}
                                                >Max</button>
                                            </div>
                                            <span className={`cmnErrorHint`}>{errors?.amount && errors?.amount}</span>

                                        </div>
                                        <div className="d-flex gap-2 ">
                                            <button className='primaryBtn' onClick={() => { buyToken() }}
                                                disabled={saleHook.isUpcoming(parseInt(saleInfo?.presaleStart)) ||
                                                    saleInfo?.ready == 2 ||
                                                    saleHook.isSaleEnded(parseInt(saleInfo?.presaleStart), parseInt(saleInfo?.presaleEnd)) || buy == true}>
                                                {isbuy ? 'Buying...' : 'Buy'}
                                            </button>

                                            <button
                                                onClick={() => { Claim() }} className='primaryBtn'
                                                disabled={isEmpty(userinfo) || saleInfo?.ready !== 2 || (saleInfo.isVested == false && !isEmpty(userinfo?.lastClaimed))}

                                            >
                                                {isclaim && saleInfo?.isVested == false ? 'Claiming...' :
                                                    isclaim && saleInfo?.isVested == true ? 'Claiming Vest...' :
                                                        !isclaim && saleInfo?.isVested == true ? 'Vesting Claim'
                                                            : 'Claim'}
                                            </button>
                                        </div>

                                    </div>

                                    <div className={styles.tablePart}>
                                        <div>
                                            <table className={styles.tableOne}>
                                                <thead>
                                                    <tr>
                                                        <th>Status</th>
                                                        <th>Minimum Buy</th>
                                                        <th>Maximum Buy</th>
                                                        <th>You Purchased</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>{saleInfo && saleHook.isUpcoming(parseInt(saleInfo?.presaleStart)) ?


                                                            "Coming up"

                                                            : saleInfo && saleInfo.ready !== 2 && saleHook.isSaleLive(saleInfo.presaleStart, saleInfo.presaleEnd) ?

                                                                "Live"
                                                                : saleInfo.ready == 2 || saleHook.isSaleEnded(parseInt(saleInfo?.presaleStart), parseInt(saleInfo?.presaleEnd)) ?

                                                                    "Closed"
                                                                    : <></>
                                                        }</td>
                                                        <td>{saleInfo && saleInfo?.minimumBuy / LAMPORTS_PER_SOL} {saleInfo?.buyMint?.toString() == Config?.SOL ? "SOL" :
                                                            saleInfo?.buyMint?.toString() == Config?.USDT ? "USDT" :
                                                                saleInfo?.buyMint?.toString() == Config?.USDC ? "USDC" : "DAI"}</td>
                                                        <td>{saleInfo && saleInfo?.maximumBuy / LAMPORTS_PER_SOL}  {saleInfo?.buyMint?.toString() == Config?.SOL ? "SOL" :
                                                            saleInfo?.buyMint?.toString() == Config?.USDT ? "USDT" :
                                                                saleInfo?.buyMint?.toString() == Config?.USDC ? "USDC" : "DAI"}</td>
                                                        <td>
                                                            {saleInfo?.ready == 0 && saleInfo?.launchType == "FairLaunch" && parseInt(saleInfo?.presaleStart) < Date.now() ?
                                                                <>  {userinfo && !isEmpty(userinfo?.tokensBooked) ? (parseInt(userinfo?.tokensBooked) / LAMPORTS_PER_SOL) : 0} {saleDBInfo?.symbol}</>
                                                                : <>                              {userinfo && !isEmpty(userinfo?.tokensBooked) ? (parseInt(userinfo?.tokensBooked) / LAMPORTS_PER_SOL) : 0} {saleDBInfo?.symbol}
                                                                </>}

                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div>
                                            <table className={styles.tableTwo}>
                                                <thead>
                                                    <tr>
                                                        <th>Sale Type</th>
                                                        <th>Total Contributors</th>
                                                        <th>My Contribution</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>{saleInfo?.isWhitelist == false ? 'Public' : 'Private'}</td>
                                                        <td> {saleInfo && (parseInt(saleInfo?.currencyRaised) / LAMPORTS_PER_SOL)}  {saleInfo?.buyMint?.toString() == Config?.SOL ? "SOL" :
                                                            saleInfo?.buyMint?.toString() == Config?.USDT ? "USDT" :
                                                                saleInfo?.buyMint?.toString() == Config?.USDC ? "USDC" : "DAI"}</td>
                                                        <td> {userinfo && !isEmpty(userinfo?.userInvested) ? (parseInt(userinfo?.userInvested) / LAMPORTS_PER_SOL) : 0}  {saleInfo?.buyMint?.toString() == Config?.SOL ? "SOL" :
                                                            saleInfo?.buyMint?.toString() == Config?.USDT ? "USDT" :
                                                                saleInfo?.buyMint?.toString() == Config?.USDC ? "USDC" : "DAI"}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {saleInfo?.authority?.toString() == walletdetail?.walletaddress ?

                                <div className={styles.ownerzonePart}>
                                    <div className={styles.titlePart}>
                                        <h2>Owner zone</h2>
                                    </div>
                                    <div className={styles.poolActionsList}>
                                        <h3>Pool Actions</h3>
                                        <ul>
                                            {/* <li>
                                    <button>Stop sale</button>
                                </li> */}
                                            <li>
                                                <button onClick={() => {
                                                    finalizeSale()
                                                }}
                                                    disabled={saleInfo?.ready == 2 || saleHook.isUpcoming(parseInt(saleInfo?.presaleStart)) || saleHook.isSaleEnded(parseInt(saleInfo?.presaleStart), parseInt(saleInfo?.presaleEnd))}>


                                                    {isfinalize ? 'Finalizing...' : 'Finalize'}

                                                </button>
                                            </li>
                                            {/* <li>
                                    <button>
                                        Get Unsold Token
                                    </button>
                                </li>
                                <li>
                                    <button>
                                        Withdraw USDC
                                    </button>
                                </li> */}
                                        </ul>
                                    </div>
                                </div>
                                : <></>}
                        </div>
                    </div>
                </>

                : <h2 className='noDataText  text-white'>No sale Available now</h2>}
            <div className={styles.lanunchpadBgPatten}>
                <img className={styles.exploreCircle1Icon} src={Images.exploreCircle1Icon} alt="circle Shape" />
                <img className={styles.exploreCircle2Icon} src={Images.exploreCircle2Icon} alt="circle Shape" />
                <img className={styles.exploreCircle3Icon} src={Images.exploreCircle3Icon} alt="circle Shape" />
                <img className={styles.exploreCircle4Icon} src={Images.exploreCircle4Icon} alt="circle Shape" />
                <img className={styles.exploreCircle5Icon} src={Images.exploreCircle5Icon} alt="circle Shape" />
                <div className={styles.darkThemeCoinImg21}>
                    <ThemeImg dynamicPath={"themeCoinImg1"} />
                </div>
            </div>
        </div>
    )
}
